
import { isPlatformBrowser, Location } from '@angular/common';
import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { PurchaseOrderEnums } from 'src/app/enum/purchase-order-enum';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { PurchaseOrderPrintModel } from 'src/app/models/shopping/purchase-order-print.model';
import { PurchaseOrderModel } from 'src/app/models/shopping/purchase-order.model';
import { PurchaseDetailRegisterModel } from 'src/app/models/tables/shopping/purchase-order-detail-register-table.model';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { PurchaseOrderService } from 'src/app/services/shopping/purchase-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-purchase-order',
  templateUrl: './register-purchase-order.component.html',
  styleUrls: ['./register-purchase-order.component.scss'],
  standalone: false
})
export class RegisterPurchaseOrderComponent implements OnInit {

  address: string = "";
  ascendant: boolean = true;
  branchId: number = 0;
  classState: string = "";
  columnSort: string | null = null;
  companyId: number = 0;
  detailData: PagedResponseModel<PurchaseDetailRegisterModel> = new PagedResponseModel<PurchaseDetailRegisterModel>();
  detailHeader: ColumnResponseModel[] = [];
  disableActions: boolean = true;
  disableAnnul: boolean = false;
  disableClose: boolean = false;
  disableDetail: boolean = true;
  disableForm: boolean = false;
  disableReverseState: boolean = false;
  finishLoadingPrint: boolean = false;
  formatModel: FormatModel = new FormatModel();
  formPurchaseOrderFirst: FormGroup = new FormGroup({});
  formPurchaseOrderFooter: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listBranches: any[] = [];
  listEnterprises: any[] = [];
  listProviders: any[] = [];
  listWayToPays: any[] = [
    {
      value: PurchaseOrderEnums.wayToPayCredit,
      label: 'Crédito'
    },
    {
      value: PurchaseOrderEnums.wayToPayCash,
      label: 'Contado'
    }
  ];
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Orden de Compra';
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  purchaseOrderId: number;
  purchaseOrderModel: PurchaseOrderModel = new PurchaseOrderModel();
  purchaseOrderPrint: PurchaseOrderPrintModel = new PurchaseOrderPrintModel();
  purchaseOrderStateString: string = "";
  quantityDetails: number = 0;
  showAccordion: boolean = false;
  severityState: string = "danger";
  url: string = "purchase-order";
  userAuthenticated: UserModel = new UserModel();

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formatService: FormatService,
    private formBuilder: FormBuilder,
    private location: Location,
    private optionWindowService: OptionWindowService,
    private providerService: ProviderService,
    private purchaseOrderService: PurchaseOrderService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private headerService: HeaderService,
    @Inject(PLATFORM_ID) private platformId: object) {
    this.validateForm(this.purchaseOrderModel);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.purchaseOrderId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  annulPurchaseOrder() {
    if (this.purchaseOrderModel.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La orden de compra no está guardada.'
      );
      return;
    }

    if (this.permissionUpdatable) {
      Swal.fire({
        title: 'Atención',
        text: 'Al anular la orden de compra, se eliminarán todo sus detalles. ¿Realmente desear anular esta orden de compra?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.annulPurchaseOrder(this.purchaseOrderModel.purchaseOrderId));
          this.validateForm(this.purchaseOrderModel);
          this.toastHandlerService.showToast(
            'success',
            'El estado de la orden de compra se modificó exitosamente.'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de ordenes de compra. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async changeBranch(branchId: number) {
    this.purchaseOrderId = 0;
    const modelPurchaseOrder = new PurchaseOrderModel();
    modelPurchaseOrder.branchId = branchId;
    modelPurchaseOrder.address = this.address;
    this.purchaseOrderModel = modelPurchaseOrder;
    this.router.navigate(['/purchase-order/register']);
    try {
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } catch (error) {
      console.error('Error al buscar las empresas de la sucursal.', error);
    }
    this.validateForm(modelPurchaseOrder);
  }

  async changeConsecutive() {
    let consecutive = this.formPurchaseOrderFirst.get("consecutive")?.value;
    if (consecutive === "") consecutive = 0;
    if (this.purchaseOrderModel.consecutive == consecutive) return;

    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    if (consecutive == null || consecutive === "") {
      this.purchaseOrderId = 0;
      const modelPurchaseOrder = new PurchaseOrderModel();
      modelPurchaseOrder.branchId = this.branchId;
      this.purchaseOrderModel = modelPurchaseOrder;
    } else {
      try {
        this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getPurchaseOrderByKeys(this.branchId, consecutive));
        this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
        this.validateForm(this.purchaseOrderModel);
        this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
      } catch (error) {
        const modelPurchaseOrder = new PurchaseOrderModel();
        modelPurchaseOrder.branchId = this.branchId;
        this.purchaseOrderModel = modelPurchaseOrder;
        console.error('Error al buscar la orden de compra por llaves.', error);
      }
    }
  }

  close() {
    this.router.navigate(['/purchase-order']);
  }

  closePurchaseOrder() {
    if (this.purchaseOrderModel.purchaseOrderState == PurchaseOrderEnums.stateOpen) {
      this.initialClosePurchaseOrder();
    } else {
      this.finalClosePurchaseOrder();
    }
  }

  async createNewPurchaseOrder() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.permissionUpdatable) {
        this.purchaseOrderId = 0;
        this.quantityDetails = 0;
        this.purchaseOrderModel = new PurchaseOrderModel();
        this.purchaseOrderModel.consecutive = 0;
        this.purchaseOrderModel.branchId = this.branchId;
        this.purchaseOrderModel.address = this.address;
        await this.validateForm(this.purchaseOrderModel);
        this.location.replaceState(`/purchase-order/register`);
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para crear ordenes de compra. Comuníquese con el administrador del sistema.'
        );
      }
    }
  }

  async deletePurchaseOrder() {
    if (this.purchaseOrderModel.purchaseOrderId != 0) {
      if (this.permissionUpdatable) {
        const result = await Swal.fire({
          title: 'Atención',
          text: `¿Realmente desea eliminar la orden de compra ${this.purchaseOrderModel.consecutive}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        });
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.purchaseOrderService.deletePurchaseOrder(this.purchaseOrderModel.purchaseOrderId));
            this.toastHandlerService.showToast(
              'success',
              'La orden de compra fue eliminada exitosamente.'
            );
            this.createNewPurchaseOrder();
          } catch (error) {
            console.error('Error al eliminar la orden de compra.', error);
          }
        }
      } else {
        this.toastHandlerService.showToast(
          'error',
          'El usuario no tiene permisos para eliminar ordenes de compra. Comuníquese con el administrador del sistema.'
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado de la orden de compra.'
      );
    }
  }

  async finalClosePurchaseOrder() {
    if (this.purchaseOrderModel.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La orden de compra no está guardada.'
      );
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.finalClosePurchaseOrder(this.purchaseOrderModel.purchaseOrderId));
        this.validateForm(this.purchaseOrderModel);
        this.toastHandlerService.showToast(
          'success',
          'El estado de la orden de compra se modificó exitosamente.'
        );
      } catch (error) {
        console.error('Error al cambiar el estado de la orden de compra.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de ordenes de compra. Comuníquese con el administrador del sistema.'
      );
    }
  }

  finishLoading(finish: boolean) {
    this.finishLoadingPrint = finish;
  }

  async handleInitialState() {
    if (this.purchaseOrderId !== null && this.purchaseOrderId !== 0) {
      await this.getPurchaseOrderById();
    } else {
      await this.getFirstBranchEnterprise();
      this.createNewPurchaseOrder();
    }
  }

  async getAllLists(
    ...listsToLoad: Array<'branches' | 'enterprises' | 'providers'>
  ) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        enterprises: async () => {
          this.listEnterprises = await firstValueFrom(
            this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId)
          );
        },
        providers: async () => {
          this.listProviders = await firstValueFrom(
            this.providerService.getAllProvidersForSelect()
          );
        }
      };

      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.enterprises(),
          lists.providers(),
        ]);
      }

      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId != null) {
      const branch = await firstValueFrom(this.branchService.getBranchById(branchId));
      if (branch) {
        this.branchId = branchId;
        this.address = branch.address;
        this.formPurchaseOrderFirst.controls["branchId"].patchValue(this.branchId);
      } else {
        this.formPurchaseOrderFirst.controls["branchId"].patchValue(null);
        this.branchId = 0;
        return;
      }
    } else {
      this.formPurchaseOrderFirst.controls["branchId"].patchValue(null);
      this.branchId = 0;
    }
    if (reload) {
      this.changeBranch(this.branchId);
    }
  }

  async getButtonClick(buttonClick: any) {
    let consecutive = this.formPurchaseOrderFirst.get("consecutive")?.value;
    if (consecutive === "") consecutive = 0;
    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getFirstPurchaseOrderByKeys(this.branchId));
          this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
          this.validateForm(this.purchaseOrderModel);
          this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
        } catch (error) {
          console.error('Error al buscar la primera factura.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getPreviusPurchaseOrderByKeys(this.branchId, consecutive));
          this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
          this.validateForm(this.purchaseOrderModel);
          this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
        } catch (error) {
          console.error('Error al buscar la factura anterior.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getNextPurchaseOrderByKeys(this.branchId, consecutive));
          this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
          this.validateForm(this.purchaseOrderModel);
          this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
        } catch (error) {
          console.error('Error al buscar la factura siguiente.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getLastPurchaseOrderByKeys(this.branchId));
          this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
          this.validateForm(this.purchaseOrderModel);
          this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
        } catch (error) {
          console.error('Error al buscar la ultima factura.', error);
        }
        break;
      }
    }
  }

  async getEnterprise(enterpriseId: number | null) {
    const enterpriseOld = this.purchaseOrderModel.enterpriseId;
    if (enterpriseId != null && enterpriseId != 0) {
      if (enterpriseOld != enterpriseId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'warning',
          'No puede cambiar la empresa si la orden de compra tiene detalle.'
        );
      } else {
        const enterprise = await firstValueFrom(this.enterpriseService.getEnterpriseById(enterpriseId));
        if (enterprise) {
          const exist = this.listEnterprises.some(x => x.value === enterpriseId);
          if (!exist) {
            this.listEnterprises.push({ label: `${enterprise.code} - ${enterprise.businessName}`, value: enterprise.enterpriseId });
          }
        } else {
          this.toastHandlerService.showToast(
            'error',
            'Error al buscar el elemento, por favor refresque la página.'
          );
          this.formPurchaseOrderFirst.controls["enterpriseId"].patchValue(null);
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar la empresa si la orden de compra tiene detalle.'
        );
      } else {
        this.formPurchaseOrderFirst.controls["enterpriseId"].patchValue(null);
      }
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    this.mainBranchByUser = await firstValueFrom(
      this.userAuthenticatedService.branchObservable.pipe(
        filter(branch => branch && branch.branchId !== 0)
      )
    );
    this.branchId = this.mainBranchByUser.branchId;
    this.companyId = this.mainBranchByUser.companyId;
    this.address = this.mainBranchByUser.address;
  }

  async getFirstBranchEnterprise() {
    try {
      await this.getBranch(this.mainBranchByUser.branchId, false);
    } catch (error) {
      console.error('Error al buscar la sucursal del usuario autenticado.', error);
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0)
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.purchaseOrder));
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getPermissionsForUserByWindow();
      await this.getAllLists();
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Invoice));
  }

  async getProvider(providerId: number | null) {
    const providerOld = this.purchaseOrderModel.providerId;
    if (providerId != null && providerId != 0) {
      if (providerOld != providerId && this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede cambiar el proveedor si la orden de compra tiene detalle.'
        );
      } else {
        const provider = await firstValueFrom(this.providerService.getProviderByIdForSelect(providerId));
        if (provider) {
          if (!provider.active) {
            this.toastHandlerService.showToast(
              'warning',
              'El proveedor seleccionado se encuentra inactivo.'
            );
            this.formPurchaseOrderFirst.controls["providerId"].patchValue(null);
            return;
          }

          const exist = this.listProviders.some(x => x.value === providerId);
          if (!exist) {
            this.listProviders.push({ label: provider.label, value: provider.value });
          }
        } else {
          this.toastHandlerService.showToast(
            'error',
            'Error al buscar el elemento, por favor refresque la página.'
          );
          this.formPurchaseOrderFirst.controls["providerId"].patchValue(null);
        }
      }
    } else {
      if (this.quantityDetails != 0) {
        this.toastHandlerService.showToast(
          'error',
          'No puede limpiar el proveedor si la orden de compra tiene detalle.'
        );
      } else {
        this.formPurchaseOrderFirst.controls["providerId"].patchValue(null);
      }
    }
  }

  async getPurchaseOrderById() {
    try {
      this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.getPurchaseOrderById(this.purchaseOrderId));
      if (this.branchId != this.purchaseOrderModel.branchId) {
        this.branchId = this.purchaseOrderModel.branchId;
        try {
          this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
        } catch (error) {
          console.error('Error al buscar las empresas de la sucursal.', error);
        }
      }
      this.validateForm(this.purchaseOrderModel);
      this.branchId = this.purchaseOrderModel.branchId;
    } catch (error) {
      console.error('Error al buscar la factura.', error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate(['/purchase-order']);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  async initialClosePurchaseOrder() {
    if (this.purchaseOrderModel.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La orden de compra no está guardada.'
      );
      return;
    }
    if (this.permissionUpdatable) {
      try {
        this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.initialClosePurchaseOrder(this.purchaseOrderModel.purchaseOrderId));
        this.validateForm(this.purchaseOrderModel);
        this.toastHandlerService.showToast(
          'success',
          'El estado de la orden de compra se modificó exitosamente.'
        );
      } catch (error) {
        console.error('Error al cambiar el estado de la orden de compra.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de ordenes de compra. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async printPage() {
    if (this.purchaseOrderModel.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La orden de compra no está guardada.'
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    Promise.all([this.printPurchaseOrder(), this.getFormatByCompanyAndCode()]);

    this.finishLoadingPrint = false;
    await this.waitForComponenteImpresionToLoad();
  }

  async printPurchaseOrder() {
    this.purchaseOrderPrint = await firstValueFrom(this.purchaseOrderService.printPurchaseOrder(this.purchaseOrderId));
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.purchaseOrderId != 0 && this.purchaseOrderId != null) {
      this.router.navigate(['/purchase-order/register/', this.purchaseOrderId]);
    } else {
      this.router.navigate(['/purchase-order/register']);
    }
  }

  async reverseStatePurchaseOrder() {
    if (this.purchaseOrderModel.consecutive == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'La orden de compra no está guardada.'
      );
      return;
    }
    if (this.permissionUpdatable) {
      this.purchaseOrderModel = await firstValueFrom(this.purchaseOrderService.reverseStatePurchaseOrder(this.purchaseOrderModel.purchaseOrderId));
      this.validateForm(this.purchaseOrderModel);
      this.toastHandlerService.showToast(
        'success',
        'El estado de la orden de compra se modificó exitosamente.'
      );
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estados de ordenes de compra. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async send(): Promise<any> {
    if (this.formPurchaseOrderFirst.valid) {
      const modelPurchaseOrder = this.formPurchaseOrderFirst.value as PurchaseOrderModel;

      //Hago null, los campos que permiten ser nulos:
      if (this.formPurchaseOrderFirst.get("alterNumber")?.value == "" || modelPurchaseOrder.alterNumber == 0)
        modelPurchaseOrder.alterNumber = null;
      if (modelPurchaseOrder.referenceDocument == "") modelPurchaseOrder.referenceDocument = null;
      if (modelPurchaseOrder.observation == "") modelPurchaseOrder.observation = null;

      if (this.purchaseOrderId == 0) {
        try {
          const response = await firstValueFrom(this.purchaseOrderService.createPurchaseOrder(modelPurchaseOrder));
          this.toastHandlerService.showToast(
            'success',
            'La orden de compra fue creada exitosamente.'
          );
          this.purchaseOrderModel = response;
          this.purchaseOrderId = this.purchaseOrderModel.purchaseOrderId;
          this.validateForm(this.purchaseOrderModel);
          this.location.replaceState(`/purchase-order/register/${this.purchaseOrderId}`);
        } catch (error) {
          console.error('Error al crear la orden de compra.', error);
        }
      } else {
        try {
          this.purchaseOrderModel.alterNumber = modelPurchaseOrder.alterNumber;
          this.purchaseOrderModel.datePurchaseOrder = modelPurchaseOrder.datePurchaseOrder;
          this.purchaseOrderModel.enterpriseId = modelPurchaseOrder.enterpriseId;
          this.purchaseOrderModel.providerId = modelPurchaseOrder.providerId;
          this.purchaseOrderModel.address = modelPurchaseOrder.address;
          this.purchaseOrderModel.wayToPay = modelPurchaseOrder.wayToPay;
          this.purchaseOrderModel.referenceDocument = modelPurchaseOrder.referenceDocument;
          this.purchaseOrderModel.observation = modelPurchaseOrder.observation;
          const response = await firstValueFrom(this.purchaseOrderService.updatePurchaseOrder(this.purchaseOrderModel));
          this.toastHandlerService.showToast(
            'success',
            'La orden de compra fue modificada exitosamente.'
          );
          this.purchaseOrderModel = response;
          this.validateForm(this.purchaseOrderModel);
        } catch (error) {
          console.error('Error al actualizar la orden de compra.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: any = {
      branchId: 'El campo sucursal es obligatorio.',
      consecutive: 'El campo consecutivo es obligatorio.',
      datePurchaseOrder: 'El campo fecha es obligatorio.',
      enterpriseId: 'El campo empresa es obligatorio.',
      wayToPay: 'El campo forma de pago es obligatorio.',
      providerId: 'El campo proveedor es obligatorio.',
      referenceDocument: 'El campo documento referencia no puede tener más de 10 caracteres.',
      address: 'El campo dirección es obligatorio.',
      observation: 'El campo observación no puede tener más de 250 caracteres'
    };
    Object.keys(controlMessages).forEach(control => {
      if (this.formPurchaseOrderFirst.controls[control].invalid) {
        this.toastHandlerService.showToast(
          'warning',
          controlMessages[control]
        );
      }
    });
  }

  async updateFormState() {
    switch (this.purchaseOrderModel.purchaseOrderState) {
      case PurchaseOrderEnums.stateOpen: {
        this.severityState = 'danger';
        this.classState = 'text-danger';
        this.purchaseOrderStateString = "Abierta";
        this.disableAnnul = false;
        this.disableClose = false;
        this.disableReverseState = true;
        break;
      }
      case PurchaseOrderEnums.stateAnnul: {
        this.severityState = 'warn';
        this.classState = '';
        this.purchaseOrderStateString = "Anulada";
        this.disableAnnul = true;
        this.disableClose = true;
        this.disableReverseState = false;
        break;
      }
      case PurchaseOrderEnums.stateInitialClose: {
        this.severityState = 'info';
        this.classState = '';
        this.purchaseOrderStateString = "Cierre (Inicial)";
        this.disableAnnul = false;
        this.disableClose = false;
        this.disableReverseState = false;
        break;
      }
      case PurchaseOrderEnums.stateFinalClose: {
        this.severityState = 'success';
        this.classState = '';
        this.purchaseOrderStateString = "Cierre (Final)";
        this.disableAnnul = true;
        this.disableClose = true;
        this.disableReverseState = false;
        break;
      }
    }
    if (this.purchaseOrderModel.purchaseOrderState === PurchaseOrderEnums.stateOpen ||
      this.purchaseOrderModel.purchaseOrderState === PurchaseOrderEnums.stateInitialClose) {
      this.disableForm = false;
      setTimeout(() => this.formPurchaseOrderFirst.enable(), 100);
      if (this.purchaseOrderId != 0) {
        setTimeout(() => this.formPurchaseOrderFirst.controls["consecutive"].enable(), 100);
      } else {
        setTimeout(() => this.formPurchaseOrderFirst.controls["consecutive"].disable(), 100);
      }
    } else {
      this.disableForm = true;
      setTimeout(() => this.formPurchaseOrderFirst.disable(), 100);
      setTimeout(() => this.formPurchaseOrderFirst.controls["branchId"].enable(), 100);
      setTimeout(() => this.formPurchaseOrderFirst.controls["consecutive"].enable(), 100);
    }
    setTimeout(() => this.formPurchaseOrderFooter.disable(), 100);

    //Valido si el usuario tiene permisos de actualizacion
    if (!this.permissionUpdatable) {
      setTimeout(() => this.formPurchaseOrderFirst.disable(), 100);
      setTimeout(() => this.formPurchaseOrderFirst.controls["branchId"].enable(), 100);
      setTimeout(() => this.formPurchaseOrderFirst.controls["consecutive"].enable(), 100);
    }
  }

  async validateForm(purchaseOrder: PurchaseOrderModel) {
    return new Promise((resolve) => {
      this.formPurchaseOrderFirst = this.formBuilder.group({
        branchId: [purchaseOrder.branchId, [Validators.required, Validators.min(1)]],
        consecutive: [purchaseOrder.consecutive, [Validators.required]],
        alterNumber: [purchaseOrder.alterNumber],
        datePurchaseOrder: [purchaseOrder.datePurchaseOrder ?
          this.dateConverterService.convertUtcToLocalDate(purchaseOrder.datePurchaseOrder) : null, [Validators.required]],
        enterpriseId: [purchaseOrder.enterpriseId, [Validators.required, Validators.min(1)]],
        wayToPay: [purchaseOrder.wayToPay, [Validators.required, Validators.min(1)]],
        providerId: [purchaseOrder.providerId, [Validators.required, Validators.min(1)]],
        referenceDocument: [purchaseOrder.referenceDocument, [Validators.maxLength(10)]],
        address: [purchaseOrder.address, [Validators.required, Validators.maxLength(100)]],
        observation: [purchaseOrder.observation, [Validators.maxLength(250)]]
      });

      this.formPurchaseOrderFooter = this.formBuilder.group({
        subtotalValue: [purchaseOrder.subtotalValue, [Validators.min(0), Validators.max(99999999999.99)]],
        ivaValue: [purchaseOrder.ivaValue, [Validators.min(0), Validators.max(99999999999.99)]],
        totalValue: [purchaseOrder.subtotalValue + purchaseOrder.ivaValue, [Validators.min(0), Validators.max(99999999999.99)]]
      });

      this.updateFormState();
      resolve(true);
    });
  }

  waitForComponenteImpresionToLoad(): Promise<void> {
    return new Promise<void>((resolve) => {
      // Verifica si el componente de impresión ha terminado de cargar (por ejemplo, si hay una variable que indique que se ha cargado completamente)
      if (this.finishLoadingPrint) {
        //Imprimimos el documento
        print();
        resolve();
      } else {
        // Si no ha terminado de cargar, espera un breve tiempo y vuelve a verificar
        setTimeout(() => this.waitForComponenteImpresionToLoad().then(resolve), 100);
      }
    });
  }
}
